'use strict';

const setAllPreOrders = (state, preOrders) => {
  state.preOrders = preOrders;
};

const addPreOrder = (state, preOrder) => {
  state.preOrders.unshift(preOrder);
};

const updatePreOrder = (state, preOrder) => {
  const index = state.preOrders.findIndex(p => p.id === preOrder.id);
  if (index !== -1) {
    state.preOrders.splice(index, 1, preOrder);
  }
};

const removePreOrder = (state, id) => {
  state.preOrders = state.preOrders.filter(p => p.id !== id);
};

export default {
  setAllPreOrders,
  addPreOrder,
  updatePreOrder,
  removePreOrder
};
